import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";

type BusyButtonProps = ButtonProps & {
  busy?: boolean;
  icon?: ReactNode;
};

/** Spinner replaces the icon on the clicked action only. */
export function BusyButton({ busy, icon, children, disabled, ...props }: BusyButtonProps) {
  return (
    <Button disabled={disabled || busy} {...props}>
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : icon}
      {children}
    </Button>
  );
}
